/**
 * Línea de evento de sistema — render de `message_type='system'`.
 *
 * Contrato confirmado #93544 (gotcha 4): el backend nunca emitía este tipo
 * hasta "Hilos con seguimiento" — cada cambio de estado/asignación/fecha del
 * tracking inserta una reply system ("{actor} → estado: Resuelto") como audit
 * trail social. Sin render dedicado esos mensajes saldrían como burbujas
 * normales con avatar/autor, que es exactamente lo que NO son.
 *
 * Se usa como rama en los call sites de los loops de mensajes (ChannelView,
 * ThreadPanel, DockChatWindow) — NO dentro de TeamMsg/ThreadReply, porque un
 * early-return antes de sus hooks violaría rules-of-hooks.
 */
import type { ChatSystemCopy } from '../system-copy';
import { useTranslation } from '@/lib/i18n/react';
import { useThemeStore } from '@/store/theme-store';
import { richChatDate, richChatNames } from '../view-copy';
import { ChatLiteralCopy } from './ChatLiteralCopy';

export function SystemMessageLine({ content, copy }: { content?: string; copy?: ChatSystemCopy }) {
  const { t } = useTranslation('teamchat');
  useThemeStore(state=>state.timeFormat);
  const changes=copy?.changes.map(change=>{
    const value=change.value===null?'—':change.field==='status'||change.field==='priority'?t(`tracking.${change.field}.${change.value}`):change.field==='due'?richChatDate(change.value):change.value;
    return t(`tracking.field.${change.field}`)+' → '+value;
  });
  const details=changes?.length?': '+richChatNames(changes):'';
  const text = (content ?? '').trim();
  if (!text && !copy) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '3px 12px' }}>
      <span
        style={{
          fontSize: 11,
          color: 'var(--fg-dim)',
          border: '1px solid var(--line)',
          borderRadius: 999,
          padding: '2px 10px',
          textAlign: 'center',
          maxWidth: '85%',
        }}
      >
        {copy?<ChatLiteralCopy copyKey={'tracking.audit.'+copy.kind.slice('tracking.'.length)} values={{actor:copy.actor_name||t('tracking.actor'),changes:details}}/>:<bdi dir="auto">{renderTextWithMentions(text, { mentions: false })}</bdi>}
      </span>
    </div>
  );
}
import { renderTextWithMentions } from '@/lib/utils/render-mentions';
